import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f36abd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "row pl-4 pt-2 pb-3 gutter--xs2 gutter--md4" }
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Select a Subscription Type to Create:", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "flex xs1"
}

import { ref } from "vue";
import { SubscriptionTypes, SubscriptionTypesName, SubscriptionTypesSymbol } from "@/notifi_types";

/* global defineProps, defineEmits */
type SubTypeNames = SubscriptionTypesName | "new";


export default /*#__PURE__*/_defineComponent({
  props: ["modelValue"],
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props




const subTypes = ref<typeof SubscriptionTypes>(SubscriptionTypes);
const subType = ref<SubTypeNames>(props.modelValue as SubscriptionTypesName);

const clear = (): void => {
  subType.value = "new";
  emit("update:modelValue", "new");
};

const selectType = (t: SubTypeNames): void => {
  subType.value = t;
  emit("update:modelValue", t);
};

const showSubtype = (t: SubTypeNames) => {
  if (subType.value == "new") return t != SubscriptionTypes.position;
  return subType.value == t;
};

// returns the current user or raises an error if none
const typeIcon = (t: SubscriptionTypesName): string => {
  if (t == SubscriptionTypes.wallet) {
    return "account_balance_wallet";
  } else if (t == SubscriptionTypes.protocol) {
    return "announcement";
  } else if (t == SubscriptionTypes.contract) {
    return "gavel";
  }
  return "";
};
const typeContent = (t: SubscriptionTypesName): string => {
  if (t == SubscriptionTypes.wallet) {
    return "Alerts for transactions that occur in your wallet(s).";
  } else if (t == SubscriptionTypes.protocol) {
    return "Ad Hoc updates and information from your Protocols";
  } else if (t == SubscriptionTypes.contract) {
    return "Smart contract alerts for Events which occur on chain";
  } else if (t == SubscriptionTypes.position) {
    return "Alerts for changes in a current Position";
  }
  return "";
};

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
        [_vShow, subType.value == undefined]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTypes.value, (type) => {
        return _withDirectives((_openBlock(), _createBlock(_component_va_card, {
          class: "flex sm3 mr-2",
          key: type,
          href: "#",
          color: subType.value == type ? '#DDD' : '#FFF',
          stripe: true,
          "stripe-color": subType.value == type ? 'info' : 'dark',
          onClick: _withModifiers(($event: any) => (selectType(type)), ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: typeIcon(type)
                }, null, 8, ["name"]),
                _createTextVNode(" " + _toDisplayString(type), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_va_card_content, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(typeContent(type)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["color", "stripe-color", "onClick"])), [
          [_vShow, (subType.value == 'new' && type != 'Position') || type == subType.value]
        ])
      }), 128)),
      (subType.value != `new`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_va_button, {
              onClick: clear,
              size: "small",
              color: "secondary",
              icon: "clear",
              class: "float-right"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})